import {defineStore} from 'pinia';
import {deleteFile, FileType, getFile, getUnattachedFile, saveFile, StorageFile} from "@/scripts/api/storage";
import {useToast} from "vue-toastification";

const toast= useToast();

export const useStorage = defineStore('useStorage', {
    actions: {
        async saveFile(file: File, fileType: FileType) {
            try {
                return await saveFile(file, fileType);
            } catch (error: any) {
                toast.error(error.response?.data.message);
            }
        },

        async deleteFile(file: StorageFile) {
            try {
                return await deleteFile(file);
            } catch (error: any) {
                toast.error(error.response?.data.message);
            }
        },

        async getUnattachedFile(fileType: FileType) {
            try {
                return await getUnattachedFile(fileType);
            } catch (error: any) {
                toast.error(error.response?.data.message);
            }
        },

        async getFile(fileId: number) {
            try {
                return await getFile(fileId);
            } catch (error: any) {
                toast.error(error.response?.data.message);
            }
        },
    }
})